export const Actions = Object.freeze({
  LIST: 'list',
  VIEW: 'view',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  PROCESS: 'process',
  APPROVE: 'approve',
});

export const Subjects = Object.freeze({
  ALL: 'all',
  PAYROLL: 'payroll',
  PAYROLL_PARAMETERIZATION: 'payroll.parameterization',
  PAYROLL_PARAMETERIZATION_SENSITIVE: 'payroll.parameterization.sensitive',
  PAYROLL_PARAMETERIZATION_BLOCK_CONTRACT: 'payroll.parameterization.block-contract',
  PAYROLL_REPORT_USAGE: 'payroll.report.usage',
  PAYROLL_REOPENING: 'payroll.reopening',
  PAYROLL_TRANSMISSION: 'payroll.transmission',
  BENEFIT_ORDER: 'benefit-order',
  BENEFIT_ORDER_PARAMETERIZATION: 'benefit-order.parameterization',
  BENEFIT_ORDER_REOPENING: 'benefit-order.reopening',
  NOTIFICATION: 'notification',
  REPORT_INACTIVE_COOPERATOR: 'report.inactive-cooperator',
});

export const ACTIONS = Actions;
export const SUBJECTS = Subjects;
